import { useState } from 'react';

import ErrorComponent from '@/components/common/error-component/ErrorComponent';
import Mail from '@/components/ui/icons/Mail';
import { WidgetComponent } from '@/forms/components/widget';
import useEffectOnlyOnUpdate from '@/hooks/useEffectOnlyOnUpdate/useEffectOnlyOnUpdate';

import classes from './EmailInput.module.scss';

const EmailInput = ({
	label,
	name,
	placeholder,
	inputArgs,
	readOnly,
	disabled,
	onChange,
	required,
	resDataAfterSubmit,
	form,
}: WidgetComponent) => {
	const elId = `id_${name}`;

	const [errorAfterSubmit, setErrorAfterSubmit] = useState<string[] | null>(
		null
	);

	useEffectOnlyOnUpdate(() => {
		if (resDataAfterSubmit) {
			const { errorMessage } = resDataAfterSubmit;
			if (Object.entries(errorMessage).length > 0) {
				// eslint-disable-next-line unicorn/no-lonely-if
				if (errorMessage[name]) setErrorAfterSubmit(errorMessage[name]);
			}
		}
	}, [resDataAfterSubmit]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setErrorAfterSubmit(null);
		onChange(e.target.value);
	};

	return (
		<section
			className={classes.container}
			data-error={errorAfterSubmit ? true : undefined}
		>
			{label ? (
				<label htmlFor={elId}>
					{placeholder === 'Новый e-mail' && <Mail clazz={classes.icon} />}
					{label}
				</label>
			) : null}
			<input
				form={form}
				className={classes.input}
				name={name}
				id={elId}
				onChange={handleChange}
				disabled={disabled}
				readOnly={readOnly}
				{...(inputArgs || {})}
				type='email'
				placeholder={placeholder}
				required={required}
			></input>
			{errorAfterSubmit?.map((i, idx) => {
				return (
					<ErrorComponent key={idx} clazz={classes.error}>
						{`*${i}`}
					</ErrorComponent>
				);
			})}
		</section>
	);
};

export default EmailInput;
